require.resolve("!/usr/share/hubspot/build/.bpm/packages/bender-build-tools/static-1.3344/node_modules/bender-lyaml-loader/lib/postmodern.js!./en.lyaml?sporks");

export default {
  mode: "lazy",
  source: "pricing-pages-ui-public-app/lang/payment-options-new",
  context: {
    "en": function () { return import("!/usr/share/hubspot/build/.bpm/packages/bender-build-tools/static-1.3344/node_modules/bender-lyaml-loader/lib/postmodern.js!./en.lyaml?sporks" /* webpackChunkName: "pricing-pages-ui-public-app-lang-payment-options-new-en" */); }  }
};
